const actions = {
  CREATE_EMPLOYEE_BEGIN: "CREATE_EMPLOYEE_BEGIN",
  CREATE_EMPLOYEE_SUCCESS: "CREATE_EMPLOYEE_SUCCESS",
  CREATE_EMPLOYEE_ERR: "CREATE_EMPLOYEE_ERR",

  LIST_EMPLOYEES_BEGIN: "LIST_EMPLOYEES_BEGIN",
  LIST_EMPLOYEES_SUCCESS: "LIST_EMPLOYEES_SUCCESS",
  LIST_EMPLOYEES_ERR: "LIST_EMPLOYEES_ERR",

  UPDATE_EMPLOYEE_BEGIN: "UPDATE_EMPLOYEE_BEGIN",
  UPDATE_EMPLOYEE_SUCCESS: "UPDATE_EMPLOYEE_SUCCESS",
  UPDATE_EMPLOYEE_ERR: "UPDATE_EMPLOYEE_ERR",

  DELETE_EMPLOYEE_BEGIN: "DELETE_EMPLOYEE_BEGIN",
  DELETE_EMPLOYEE_SUCCESS: "DELETE_EMPLOYEE_SUCCESS",
  DELETE_EMPLOYEE_ERR: "DELETE_EMPLOYEE_ERR",

  BLOCK_EMPLOYEE_BEGIN: "BLOCK_EMPLOYEE_BEGIN",
  BLOCK_EMPLOYEE_SUCCESS: "BLOCK_EMPLOYEE_SUCCESS",
  BLOCK_EMPLOYEE_ERR: "BLOCK_EMPLOYEE_ERR",

  UNBLOCK_EMPLOYEE_BEGIN: "UNBLOCK_EMPLOYEE_BEGIN",
  UNBLOCK_EMPLOYEE_SUCCESS: "UNBLOCK_EMPLOYEE_SUCCESS",
  UNBLOCK_EMPLOYEE_ERR: "UNBLOCK_EMPLOYEE_ERR",

  GET_EMPLOYEE_DETAILS_BEGIN: "GET_EMPLOYEE_DETAILS_BEGIN",
  GET_EMPLOYEE_DETAILS_SUCCESS: "GET_EMPLOYEE_DETAILS_SUCCESS",
  GET_EMPLOYEE_DETAILS_ERR: "GET_EMPLOYEE_DETAILS_ERR",

  createEmployeeBegin: () => {
    return {
      type: actions.CREATE_EMPLOYEE_BEGIN,
    };
  },

  createEmployeeSuccess: (data) => {
    return {
      type: actions.CREATE_EMPLOYEE_SUCCESS,
      data,
    };
  },

  createEmployeeErr: (err) => {
    return {
      type: actions.CREATE_EMPLOYEE_ERR,
      err,
    };
  },

  listEmployeesBegin: () => {
    return {
      type: actions.LIST_EMPLOYEES_BEGIN,
    };
  },

  listEmployeesSuccess: (data) => {
    return {
      type: actions.LIST_EMPLOYEES_SUCCESS,
      data,
    };
  },

  listEmployeesErr: (err) => {
    return {
      type: actions.LIST_EMPLOYEES_ERR,
      err,
    };
  },

  updateEmployeeBegin: () => {
    return {
      type: actions.UPDATE_EMPLOYEE_BEGIN,
    };
  },

  updateEmployeeSuccess: (data) => {
    return {
      type: actions.UPDATE_EMPLOYEE_SUCCESS,
      data,
    };
  },

  updateEmployeeErr: (err) => {
    return {
      type: actions.UPDATE_EMPLOYEE_ERR,
      err,
    };
  },

  deleteEmployeeBegin: () => {
    return {
      type: actions.DELETE_EMPLOYEE_BEGIN,
    };
  },

  deleteEmployeeSuccess: (data) => {
    return {
      type: actions.DELETE_EMPLOYEE_SUCCESS,
      data,
    };
  },

  deleteEmployeeErr: (err) => {
    return {
      type: actions.DELETE_EMPLOYEE_ERR,
      err,
    };
  },

  blockEmployeeBegin: () => {
    return {
      type: actions.BLOCK_EMPLOYEE_BEGIN,
    };
  },

  blockEmployeeSuccess: (data) => {
    return {
      type: actions.BLOCK_EMPLOYEE_SUCCESS,
      data,
    };
  },

  blockEmployeeErr: (err) => {
    return {
      type: actions.BLOCK_EMPLOYEE_ERR,
      err,
    };
  },

  unblockEmployeeBegin: () => {
    return {
      type: actions.UNBLOCK_EMPLOYEE_BEGIN,
    };
  },

  unblockEmployeeSuccess: (data) => {
    return {
      type: actions.UNBLOCK_EMPLOYEE_SUCCESS,
      data,
    };
  },

  unblockEmployeeErr: (err) => {
    return {
      type: actions.UNBLOCK_EMPLOYEE_ERR,
      err,
    };
  },

  getEmployeeDetailsBegin: () => {
    return {
      type: actions.GET_EMPLOYEE_DETAILS_BEGIN,
    };
  },

  getEmployeeDetailsSuccess: (data) => {
    return {
      type: actions.GET_EMPLOYEE_DETAILS_SUCCESS,
      data,
    };
  },

  getEmployeeDetailsErr: (err) => {
    return {
      type: actions.GET_EMPLOYEE_DETAILS_ERR,
      err,
    };
  },
};

export default actions;
